import React, { useEffect, useState } from 'react';
import AddButton from '../../../../Components/Button/AddButton';
import ScrollContainer from '../../../Base/Components/ScrollContainer';

// @ts-ignore
import styles from './MedicalRequestsList.module.scss';
import useDocuments from '../../../Documents/Hooks/useDocuments';
import useFlatData from '../../../Base/Hooks/useFlatData';
import { DocumentType } from '../../../../graphql/graphql';
import FlatList from '../../../Base/Components/FlatList';
import MedicalRequestsListItem from '../MedicalRequestsListItem/MedicalRequestsListItem';
import MedicalRequestCreateModal from '../MedicalRequestCreate/MedicalRequestCreateModal';
import useScope from '../../../Scope/Hooks/useScope';
import MedicalRequestPolandModal from '../../../Scope/Poland/Components/MedicalRequestPoland/MedicalRequestPolandModal';

interface Props {
	patientId: string;
	workplaceId: string;
	setIsLoading: (isLoading: boolean) => void;
}

const wrapperId = 'medicalRequestsWrapper';

const MedicalRequestsList: React.FC<Props> = ({
	patientId,
	workplaceId,
	setIsLoading,
}) => {
	const { isPoland } = useScope();
	const [isCreateRequestOpen, setIsCreateRequestOpen] = useState(false);

	const { getFlatDocuments, getNextPage, data, isLoading, page, setPage } =
		useDocuments();

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getFlatDocuments,
		{
			data: data?.documents?.data,
			totalPages: data?.documents?.meta?.totalPages,
			page: data?.documents?.meta?.page,
		},
		page,
		setPage,
	);

	useEffect(() => {
		setFilter({
			userId: patientId,
			workplaceId,
			types: [DocumentType.MedicalRequestForm],
		});
	}, []);

	const handleRefreshData = async () => {
		setIsLoading(true);
		await loadData();
		setIsCreateRequestOpen(false);
		setIsLoading(false);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.options}>
				<AddButton
					title='component.medicalRequestForms.createARequisition'
					onClick={() => setIsCreateRequestOpen(true)}
				/>
			</div>
			<ScrollContainer wrapperId={wrapperId} className={styles.list}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={wrapperId}
					renderItem={item => <MedicalRequestsListItem item={item} />}
				/>
			</ScrollContainer>
			{isCreateRequestOpen && (
				<>
					{isPoland ? (
						<MedicalRequestPolandModal
							patientId={patientId}
							isOpen
							onClose={() => setIsCreateRequestOpen(false)}
							onSuccess={handleRefreshData}
						/>
					) : (
						<MedicalRequestCreateModal
							isOpen
							setIsOpen={setIsCreateRequestOpen}
							workplaceId={workplaceId}
							patientId={patientId}
							onCreate={handleRefreshData}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default MedicalRequestsList;
